const W = (n, e) => {
  if (!n || !e)
    return u;
  const i = q(n);
  y(e) || (e = k(e));
  const a = i.bitflags;
  return (a & e._bitflags) !== a ? u : C(i, e);
};
function Y(n, e, i) {
  if (!n)
    return i && i.all ? F(n, e, i) : O;
  const a = q(n), t = a.bitflags, f = i && i.threshold || U, s = i && i.limit || P;
  let r = 0, l = 0;
  const o = e.length;
  if (i && "key" in i && i.key) {
    const w = i.key;
    for (let h = 0; h < o; ++h) {
      var c = e[h], g = z(c, w);
      if (g && (y(g) || (g = k(g)), (t & g._bitflags) === t)) {
        var v = C(a, g);
        v !== u && (v.score < f || (v = {
          target: v.target,
          _targetLower: "",
          _targetLowerCodes: u,
          _nextBeginningIndexes: u,
          _bitflags: 0,
          score: v.score,
          _indexes: v._indexes,
          obj: c,
          refIndex: h
        }, r < s ? (b.add(v), ++r) : (++l, v.score > b.peek().score && b.replaceTop(v))));
      }
    }
  } else
    for (var _ = 0; _ < o; ++_) {
      var g = e[_];
      if (g && (y(g) || (g = k(g)), (t & g._bitflags) === t)) {
        var v = C(a, g);
        v !== u && (v.refIndex = _, !(v.score < f) && (r < s ? (b.add(v), ++r) : (++l, v.score > b.peek().score && b.replaceTop(v))));
      }
    }
  if (r === 0)
    return O;
  for (var L = new Array(r), _ = r - 1; _ >= 0; --_)
    L[_] = b.poll();
  return L.total = r + l, L;
}
const Z = (n) => (
  // @ts-expect-error
  n._indexes.slice(0, n._indexes.len).sort((e, i) => e - i)
), k = (n) => {
  typeof n != "string" && (n = "");
  var e = T(n);
  return {
    target: n,
    _targetLower: e._lower,
    _targetLowerCodes: e.lowerCodes,
    _nextBeginningIndexes: u,
    _bitflags: e.bitflags,
    score: u,
    _indexes: [0],
    obj: u
  };
};
var X = (n) => {
  typeof n != "string" && (n = ""), n = n.trim();
  var e = T(n), i = [];
  if (e.containsSpace) {
    var a = n.split(/\s+/);
    a = [...new Set(a)];
    for (var t = 0; t < a.length; t++)
      if (a[t] !== "") {
        var f = T(a[t]);
        i.push({
          lowerCodes: f.lowerCodes,
          _lower: a[t].toLowerCase(),
          containsSpace: !1
        });
      }
  }
  return {
    lowerCodes: e.lowerCodes,
    bitflags: e.bitflags,
    containsSpace: e.containsSpace,
    _lower: e._lower,
    spaceSearches: i
  };
};
function q(n) {
  if (n.length > 999)
    return X(n);
  var e = M.get(n);
  return e !== void 0 || (e = X(n), M.set(n, e)), e;
}
var F = (n, e, i) => {
  var a = [];
  a.total = e.length;
  var t = i && i.limit || P;
  if (i && i.key)
    for (var f = 0; f < e.length; f++) {
      var s = e[f], r = z(s, i.key);
      if (r) {
        y(r) || (r = k(r)), r.score = U, r._indexes.len = 0;
        var l = r;
        if (l = {
          target: l.target,
          _targetLower: "",
          _targetLowerCodes: u,
          _nextBeginningIndexes: u,
          _bitflags: 0,
          score: r.score,
          _indexes: u,
          refIndex: f,
          obj: s
        }, a.push(l), a.length >= t)
          return a;
      }
    }
  else
    for (var f = 0; f < e.length; f++) {
      var r = e[f];
      if (r && (y(r) || (r = k(r)), r.score = U, r.refIndex = f, r._indexes.len = 0, a.push(r), a.length >= t))
        return a;
    }
  return a;
}, C = (n, e, i = !1) => {
  if (i === !1 && n.containsSpace)
    return H(n, e);
  for (var a = n._lower, t = n.lowerCodes, f = t[0], s = e._targetLowerCodes, r = t.length, l = s.length, v = 0, o = 0, c = 0; ; ) {
    var g = f === s[o];
    if (g) {
      if (S[c++] = o, ++v, v === r)
        break;
      f = t[v];
    }
    if (++o, o >= l)
      return u;
  }
  var v = 0, _ = !1, L = 0, w = e._nextBeginningIndexes;
  w === u && (w = e._nextBeginningIndexes = K(e.target)), o = S[0] === 0 ? 0 : w[S[0] - 1];
  var h = 0;
  if (o !== l)
    for (; ; )
      if (o >= l) {
        if (v <= 0 || (++h, h > 200))
          break;
        --v;
        var D = m[--L];
        o = w[D];
      } else {
        var g = t[v] === s[o];
        if (g) {
          if (m[L++] = o, ++v, v === r) {
            _ = !0;
            break;
          }
          ++o;
        } else
          o = w[o];
      }
  var p = e._targetLower.indexOf(
    a,
    S[0]
  ), A = ~p;
  if (A && !_)
    for (var d = 0; d < c; ++d)
      S[d] = p + d;
  var R = !1;
  A && (R = e._nextBeginningIndexes[p - 1] === p);
  {
    if (_)
      var x = m, B = L;
    else
      var x = S, B = c;
    for (var I = 0, V = 0, d = 1; d < r; ++d)
      x[d] - x[d - 1] !== 1 && (I -= x[d], ++V);
    var E = x[r - 1] - x[0] - (r - 1);
    if (I -= (12 + E) * V, x[0] !== 0 && (I -= x[0] * x[0] * 0.2), !_)
      I *= 1e3;
    else {
      for (var N = 1, d = w[0]; d < l; d = w[d])
        ++N;
      N > 24 && (I *= (N - 24) * 10);
    }
    A && (I /= 1 + r * r * 1), R && (I /= 1 + r * r * 1), I -= l - r, e.score = I;
    for (var d = 0; d < B; ++d)
      e._indexes[d] = x[d];
    return e._indexes.len = B, e;
  }
}, H = (n, e) => {
  for (var i = /* @__PURE__ */ new Set(), a = 0, t = u, f = 0, s = n.spaceSearches, c = 0; c < s.length; ++c) {
    var r = s[c];
    if (t = C(r, e), t === u)
      return u;
    a += t.score, t._indexes[0] < f && (a -= f - t._indexes[0]), f = t._indexes[0];
    for (var l = 0; l < t._indexes.len; ++l)
      i.add(t._indexes[l]);
  }
  var o = C(
    n,
    e,
    /*allowSpaces=*/
    !0
  );
  if (o !== u && o.score > a)
    return o;
  t.score = a;
  var c = 0;
  for (let g of i)
    t._indexes[c++] = g;
  return t._indexes.len = c, t;
}, T = (n) => {
  for (var e = n.length, i = n.toLowerCase(), a = [], t = 0, f = !1, s = 0; s < e; ++s) {
    var r = a[s] = i.charCodeAt(s);
    if (r === 32) {
      f = !0;
      continue;
    }
    var l = r >= 97 && r <= 122 ? r - 97 : r >= 48 && r <= 57 ? 26 : (
      // 3 bits available
      r <= 127 ? 30 : 31
    );
    t |= 1 << l;
  }
  return {
    lowerCodes: a,
    bitflags: t,
    containsSpace: f,
    _lower: i
  };
}, J = (n) => {
  var e = n.length, i = [], a = 0, t = !1, f = !1;
  for (let s = 0; s < e; ++s) {
    const r = n.charCodeAt(s), l = r >= 65 && r <= 90, o = l || r >= 97 && r <= 122 || r >= 48 && r <= 57, c = l && !t || !f || !o;
    t = l, f = o, c && (i[a++] = s);
  }
  return i;
};
const K = (n) => {
  const e = n.length, i = J(n), a = [];
  let t = i[0], f = 0;
  for (let s = 0; s < e; ++s)
    t > s ? a[s] = t : (t = i[++f], a[s] = t === void 0 ? e : t);
  return a;
}, $ = () => {
  M.clear(), S = [], m = [];
};
var M = /* @__PURE__ */ new Map(), S = [], m = [], z = (n, e) => {
  var i = n[e];
  if (i !== void 0)
    return i;
  var a = e;
  Array.isArray(e) || (a = e.split("."));
  for (var t = a.length, f = -1; n && ++f < t; )
    n = n[a[f]];
  return n;
}, y = (n) => typeof n == "object", P = 1 / 0, U = -P, O = [];
O.total = 0;
var u = null, Q = (n) => {
  var e = [], i = 0, a = {}, t = (f) => {
    for (var s = 0, r = e[s], l = 1; l < i; ) {
      var o = l + 1;
      s = l, o < i && e[o].score < e[l].score && (s = o), e[s - 1 >> 1] = e[s], l = 1 + (s << 1);
    }
    for (var c = s - 1 >> 1; s > 0 && r.score < e[c].score; c = (s = c) - 1 >> 1)
      e[s] = e[c];
    e[s] = r;
  };
  return (
    // @ts-expect-error
    a.add = (f) => {
      var s = i;
      e[i++] = f;
      for (var r = s - 1 >> 1; s > 0 && f.score < e[r].score; r = (s = r) - 1 >> 1)
        e[s] = e[r];
      e[s] = f;
    }, // @ts-expect-error
    a.poll = (f) => {
      if (i !== 0) {
        var s = e[0];
        return e[0] = e[--i], t(), s;
      }
    }, // @ts-expect-error
    a.peek = (f) => {
      if (i !== 0)
        return e[0];
    }, // @ts-expect-error
    a.replaceTop = (f) => {
      e[0] = f, t();
    }, a
  );
}, b = Q();
export {
  $ as cleanup,
  Y as go,
  Z as indexes,
  k as prepare,
  W as single
};
//# sourceMappingURL=fuzzysort.mjs.map
